"use client"

import { useContextEnrichmentPlugin } from "@/app/infra/amplitude"

const AMPLITUDE_CONTEXT = {
  page: "Profile",
}

export function ProfileAnalyticsEnrichment() {
  useContextEnrichmentPlugin("ProfilePageScopeProvider", AMPLITUDE_CONTEXT)

  return null
}
